/**
 * Checks if the code is running in a browser environment.
 * @returns {boolean} True if the code is running in a browser, false otherwise.
 */
const isBrowser = () => typeof window !== 'undefined';

/**
 * Ensures that the global `tp` queue exists in the browser environment.
 * If the code is running in a browser and the `tp` property is not defined on the `window` object,
 * it initializes `window.tp` as an empty array.
 */
function ensureQueue() {
  if (isBrowser() && !window.tp) window.tp = [];
}

/**
 * Executes a command using the `tp` function if it exists in the browser's global `window` object.
 * If the `tp` function is not available, the command is queued for later execution.
 * @param {any} cmd - The command to be executed or queued.
 */
function tpPush(cmd) {
  if (!isBrowser()) return;
  if (typeof window.tp === 'function') {
    window.tp(cmd);
  } else {
    ensureQueue();
    window.tp.push(cmd);
  }
}

/**
 * Sets the user reference token for the Piano service.
 * @param {string} token - The user reference token to be set.
 */
function setUserReference(token) {
  tpPush(['setUserRef', token]);
}

let last = 0;
/**
 * Reloads the gate experience if the required conditions are met.
 * Ensures the function is executed in a browser environment and throttles
 * execution to prevent it from running more than once per second.
 * @throws Will catch and suppress any errors thrown by `window.tp.experience.execute`.
 */
function reloadGate() {
  if (!isBrowser() || !window.tp?.experience?.execute) return;
  const now = Date.now();
  if (now - last < 1000) return;
  last = now;
  try { window.tp.experience.execute(); } catch (_) { /* no‑op */ }
}


// eslint-disable-next-line jsdoc/require-jsdoc
function startCheckout(params) {
  if (!isBrowser()) return;
  if (window.tp?.offer?.startCheckout) {
    window.tp.offer.startCheckout(params);
  } else {
    ensureQueue();
    window.tp.push(() => window.tp.offer.startCheckout(params));
  }
}

// eslint-disable-next-line import/no-default-export
export default {
  tpPush,
  setUserReference,
  reloadGate,
  startCheckout,
};
